<script>
    import { Row, Col, Button } from 'sveltestrap'
    import FormSavingButtons from '../FormSavingButtons.svelte'
    import FormAlerts from '../FormAlerts.svelte'
    import TeamInfo from './TeamInfo.svelte'
    import Icon from 'svelte-awesome'
    import { plus } from 'svelte-awesome/icons'

    export let context
    export let saving
    export let schoolId

    const addBlankTeam = () => {
        context.form.teams = [
            ...context.form.teams,
            {
                $create: true,
                id: context.form.teams.length,
                attributes: {
                    sport: '',
                    name: '',
                    arenaId: '',
                    sportIconImage: {
                        url: ''
                    }
                },
                meta: {
                    schoolId,
                    state: 'published'
                }
            }
        ]
    }
</script>

<style>
    iframe {
        margin: 50px 0;
    }
</style>

<h1>Teams</h1>

<p>Please watch the instructional video below about creating your teams.</p>

<Row>
    <Col class="text-center">
        <iframe
            title="embedded video about app naming"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/GVZy0MBWSvo"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        />
    </Col>
</Row>

<h2>Add Your Teams</h2>

<p>Please add each sports team. The Arena Name and Sport Icon will be displayed alongside the team in the app.</p>

{#each context.form.teams as team, index (team.id)}
    <Row class="mb-3">
        <Col>
            <TeamInfo bind:context formKey="teams" {index} arenas={context.view.arenas} on:change />
        </Col>
    </Row>
{/each}

<Row>
    <Col>
        <p>
            <Button on:click={addBlankTeam}>
                Add another team
                <Icon data={plus} />
            </Button>
        </p>
    </Col>
</Row>

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons {context} {saving} on:save on:nextStepClicked on:previousStepClicked />
